module.exports = __webpack_public_path__ + "static/media/fave-feed-modal-2.91854d47.svg";